export default
`Beste {naam},

Wij hebben vandaag een zending aangemeld voor verzending bij {vervoerder}. Klik op onderstaande knop om de zending te volgen.`
